import $ from "jquery";

$(document).ready(function ($) {
  function getSliderSettings() {
    return {
      slidesToShow: 6,
      arrows: true,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    };
  }

  // Reset slider on filter change
  $(".menu-slider__categories a").on("click", function (e) {
    e.preventDefault();

    var category = $(this).attr("data-type");
    var catId = $(this).attr("data-termid");
    $(".menu-slider__categories a").removeClass("active");
    $(this).addClass("active");

    var data = {
      action: "filterMenuSlider",
      category: category,
      catId: catId,
      nonce: parmCrisps_params.security,
    };

    $.ajax({
      url: parmCrisps_params.ajaxurl,
      data: data,
      type: "POST",
      beforeSend: function () {},
      success: function (response) {
        var data = $.parseJSON(response);

        var slides = data[1];
        if (slides >= 4) {
          slides = 3;
        }

        $(".menu-slider__inner").replaceWith(data[0]);

        $(".menu-slider__inner").slick(getSliderSettings(slides, false));
      },
    });
    return false;
  });
});
